import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';

import { LoadingIndicatorService } from '../platform/loading-indicator.service';

/** Zlicza żądania w locie dla globalnego wskaźnika ładowania. */
@Injectable({ providedIn: 'root' })
export class LoadingInterceptor implements HttpInterceptor {
  private readonly loading = inject(LoadingIndicatorService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.loading.start();

    return next.handle(request).pipe(finalize(() => this.loading.stop()));
  }
}
